import { Component } from '@angular/core'

import { OAuthService } from 'angular-oauth2-oidc'
import { filter } from 'rxjs'

import { authCodeFlowConfig } from './auth.config'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'mmocld-tc'
  isLoggedIn = this.oAuthService.hasValidAccessToken()

  constructor(private oAuthService: OAuthService) {
    this.oAuthService.configure(authCodeFlowConfig)
    this.oAuthService.setupAutomaticSilentRefresh()

    this.oAuthService.loadDiscoveryDocumentAndTryLogin()

    this.oAuthService.events.pipe(filter((e) => e.type === 'token_received')).subscribe(() => {
      this.oAuthService.loadUserProfile()
      this.isLoggedIn = this.oAuthService.hasValidAccessToken()
    })
  }
}
